import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { OnboardingService } from '../../../onboarding.service';
import { SharedService } from '../../../../../shared/shared.service';

@Component({
  selector: 'app-partner-business-details',
  templateUrl: './partner-business-details.component.html',
  styleUrl: './partner-business-details.component.less'
})
export class PartnerBusinessDetailsComponent implements OnInit {
  @ViewChild('pacInput', { static: false }) pacInput!: ElementRef;
  @Input() sponsorOnboardingCMSData: any;
  getGenericLabels: any;
  @Input() partnerBusinessDetails: any;
  @Output() partnerBusinessDataValueChange = new EventEmitter<any>();
  @Output() mobileImageValueChange=new EventEmitter<any>();
  @Output() apiError = new EventEmitter<any>();
  entityTypesList: any = [];
  industryTypesList: any = [];
  isRegistrationReq: boolean = true;
  addressLabelContent = 'Address';

  constructor(
    private onboardingService: OnboardingService,
    private sharedService:SharedService,
    private renderer : Renderer2
  ) {}

  ngOnInit(): void {
    this.getGenericLabels = JSON.parse(localStorage.getItem('genericLabels') || '{}');
    this.addressLabelContent = this.getGenericLabels.Address;
    this.getEntityTypesList();
    this.getIndustryTypesList();
    // this.initMap();
  }

  ngAfterViewInit() {
    this.initMap();
    this.adjustPacContainerWidth();

    // Observe DOM changes to set the width dynamically
    const observer = new MutationObserver(() => this.adjustPacContainerWidth());
    observer.observe(document.body, { childList: true, subtree: true });

    // Optionally, adjust width on window resize
    window.addEventListener('resize', () => this.adjustPacContainerWidth());
  }

  adjustPacContainerWidth() {
    setTimeout(() => {
      const inputField = this.pacInput.nativeElement;
      const pacContainers = document.getElementsByClassName('pac-container');
      if (inputField && pacContainers.length) {
        const inputWidth = inputField.offsetWidth;
        const newWidth = inputWidth; // Adding 100px to the input width
        for (let i = 0; i < pacContainers.length; i++) {
          this.renderer.setStyle(pacContainers[i], 'width', `${newWidth}px`);
          // this.renderer.setStyle(pacContainers[i], 'transform', 'translateX(-71px)');
        }
      }
    }, 0);
  }

  getEntityTypesList() {
    this.sharedService.toggleGlobalLoader(true);
    this.onboardingService.getEntityTypesList().subscribe({
      next: (res: any) => {
        res.forEach((element: any) => {
          let option = { key: element.code, value: element.name };
          this.entityTypesList.push(option);
          this.sharedService.toggleGlobalLoader(false);
        });
      },
      error: (error: any) => {
        this.sharedService.toggleGlobalLoader(false);
        // this.errorMessage = this.offersService.generateBlindError(error);
      },
    });
  }

  getIndustryTypesList() {
    this.onboardingService.getIndustryTypesList().subscribe({
      next: (res: any) => {
        res.forEach((element: any) => {
          let option = { key: element.code, value: element.name };
          this.industryTypesList.push(option);
        });
      },
      error: (error: any) => {
        // this.errorMessage = this.offersService.generateBlindError(error);
      },
    });
  }

  valueChange(event: any, key: string) {
    switch (key) {
      case 'entityType':
        this.partnerBusinessDetails.entityType = event;
        if(this.partnerBusinessDetails.entityType == 'FRANCHISEE' || this.partnerBusinessDetails.entityType == 'REG BNS') {
          this.isRegistrationReq = true;
        } else  {
          this.isRegistrationReq = false;
        }
        break;
      case 'industry':
        this.partnerBusinessDetails.industry = event;
        this.setSponsorLogo(event);
    }
    this.partnerBusinessDataValueChange.emit(this.partnerBusinessDetails);
  }

  partnerBusinessValueChange(event: any, key: string) {
    switch (key) {
      case 'businessName':
        this.partnerBusinessDetails.businessName = event;
        break;
      case 'tradingName':
        this.partnerBusinessDetails.tradingName = event;
      break;
      case 'registrationNumber':
        this.partnerBusinessDetails.registrationNumber = event;
      break;
      case 'address':
        this.partnerBusinessDetails.address = event;
    }
    this.partnerBusinessDataValueChange.emit(this.partnerBusinessDetails);
  }

  setSponsorLogo(event: any) {
    this.sponsorOnboardingCMSData.industryDefaultImage.forEach((element: any) => {
      if(event == element.fields.description) {
        this.partnerBusinessDetails.businessLogo = 'https:' + element.fields.file.url;
      }
    });
    // this.partnerAccountDataValueChange.emit(this.partnerBusinessDetails);
  }

  uploadImage(event:any){
    this.mobileImageValueChange.emit(event); 
  }

  getError(event:any){
    this.apiError.emit(event);
  }

  initMap() {
    const map = new google.maps.Map(document.getElementById("map")!, {
      zoom: 13,
      mapTypeControl: false,
    })
    const card = document.getElementById("pac-card")!;
    const input = document.getElementById("pac-input") as HTMLInputElement;
    const options = {
      fields: ["formatted_address", "geometry", "name"],
      strictBounds: false,
    }
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(card);
    const autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.bindTo("bounds", map);
    const infowindow = new google.maps.InfoWindow();
    const infowindowContent = document.getElementById("infowindow-content");
    infowindow.setContent(infowindowContent);
    const marker = new google.maps.Marker({
      map,
      anchorPoint: new google.maps.Point(0, -29),
    })
  
    autocomplete.addListener("place_changed", () => {
      infowindow.close();
      marker.setVisible(false);
      const place = autocomplete.getPlace();
      this.partnerBusinessDetails.address = place.formatted_address;
      console.log('this.partnerBusinessDetails.address',this.partnerBusinessDetails.address);
      this.partnerBusinessDataValueChange.emit(this.partnerBusinessDetails);
      if (!place.geometry || !place.geometry.location) {
        window.alert("No details available for input: '" + place.name + "'");
        return
      }
      marker.setPosition(place.geometry.location);
      marker.setVisible(true);
      infowindow.open(map, marker);
    });
  }
}
